// extracted by mini-css-extract-plugin
module.exports = {"prev_arrow":"TwitterSliderCustom_prev_arrow__MBHtP","next_arrow":"TwitterSliderCustom_next_arrow__okz_V","root":"TwitterSliderCustom_root__9SN6l"};